import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "icon-command-link" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "6",
  height: "8"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#ffffff",
    "fill-rule": "evenodd",
    d: "M1 .71L1.608 0l3.391 3.999H5v.002L4.999 4 1.608 8 1 7.29 3.801 4 1 .71z"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}